import { all, takeEvery, put, call } from "redux-saga/effects";

import { notification as notifications } from "antd";
import actions from "./actions";
import { register } from "../../services/accountService";

export function* registerRequest({ user }) {
  try {
    const response = yield call(register, user);
    if (response[0] === 200) {
      localStorage.setItem("id_token", response[1]["jwtToken"]);
      localStorage.setItem("role", response[1]["role"]);
      localStorage.setItem("status", response[1]["status"]);
      localStorage.setItem("organization", response[1]["organization"]);
      localStorage.setItem("organizationId", response[1]["organizationId"]);
      localStorage.setItem(
        "fullName",
        response[1]["firstName"] + " " + response[1]["lastName"]
      );

      window.location = "/waiting";

      notifications["success"]({
        message: "Успешена регистрация.",
      });

      yield put({
        type: actions.REGISTER_SUCCESS,
        user: response[1],
      });
    } else {
      var msg = "";

      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }

      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }

      notifications["error"]({
        message: "Неуспешна регистрация.",
        description: msg,
      });
    }
  } catch (error) {
    notifications["error"]({
      message: "Неуспешна регистрация.",
    });
  }
}

export function* registerSuccess() {
  yield takeEvery(actions.REGISTER_SUCCESS, function* (payload) {
    yield localStorage.setItem("id_token", payload.token);
  });
}

export default function* rootSaga() {
  yield all([
    yield takeEvery(actions.REGISTER_REQUEST, registerRequest),
    yield takeEvery(actions.REGISTER_SUCCESS, registerSuccess),
  ]);
}
